let offsetMs = 0;

export function now(): number {
  return Date.now() + offsetMs;
}

export function applyOffset(value: number): void {
  offsetMs = value;
}

export function clearOffset(): void {
  offsetMs = 0;
}

export function getOffset(): number {
  return offsetMs;
}
